import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import LangLink from './LangLink';

const STORAGE_KEY = 'nizus_cookie_consent';

// Export so GlobalSeoMeta can read the consent status
export const getCookieConsent = () => localStorage.getItem(STORAGE_KEY);
export const hasCookieConsent = () => localStorage.getItem(STORAGE_KEY) === 'accepted';

export default function CookieBanner() {
    const { language } = useLanguage();
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        // Show banner only if no choice has been made yet
        if (!localStorage.getItem(STORAGE_KEY)) {
            setVisible(true);
        }
    }, []);

    const accept = () => {
        localStorage.setItem(STORAGE_KEY, 'accepted');
        setVisible(false);
        // Trigger GA load if it hasn't loaded yet
        window.dispatchEvent(new Event('nizus_consent_updated'));
    };

    const reject = () => {
        localStorage.setItem(STORAGE_KEY, 'rejected');
        setVisible(false);
    };

    if (!visible) return null;

    const t = {
        message: language === 'fr'
            ? 'Nous utilisons des cookies pour analyser le trafic du site via Google Analytics et améliorer votre expérience.'
            : 'We use cookies to analyze site traffic via Google Analytics and improve your experience.',
        privacy: language === 'fr' ? 'Politique de confidentialité' : 'Privacy policy',
        accept: language === 'fr' ? 'Accepter' : 'Accept',
        reject: language === 'fr' ? 'Refuser' : 'Decline',
    };

    return (
        <div className="fixed bottom-0 left-0 right-0 z-[500] p-4 md:p-6 pointer-events-none">
            <div className="max-w-2xl mx-auto bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-2xl shadow-2xl p-4 md:p-5 pointer-events-auto animate-in slide-in-from-bottom-4 duration-300">
                <div className="flex flex-col sm:flex-row sm:items-center gap-4">
                    <div className="flex-1 text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
                        {t.message}{' '}
                        <LangLink
                            to="/privacy"
                            className="underline text-gray-800 dark:text-gray-200 hover:text-blue-600 dark:hover:text-blue-400 transition-colors"
                        >
                            {t.privacy}
                        </LangLink>
                    </div>
                    <div className="flex items-center gap-2 flex-shrink-0">
                        <button
                            onClick={reject}
                            className="px-4 py-2 text-sm font-semibold text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 border border-gray-200 dark:border-gray-700 rounded-xl hover:bg-gray-50 dark:hover:bg-white/5 transition-all"
                        >
                            {t.reject}
                        </button>
                        <button
                            onClick={accept}
                            className="px-4 py-2 text-sm font-semibold text-white bg-blue-600 hover:bg-blue-700 rounded-xl transition-all shadow-sm"
                        >
                            {t.accept}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
